import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../../auth/service/cities.service";
import { IBank } from "../../../../auth/models/bank";
import { ListService } from "../../../../auth/service/list.service";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IProvider } from "../../models/providers";
import { ProvidersService } from "../../providers.service";
import nationsWithCodes from "app/auth/models/nations-with-codes";
import { IInvoiceType } from "../../../../auth/models/invoice-type";
import { ICity } from "app/auth/models/cities";

@Component({
  selector: "app-providers-create",
  templateUrl: "./providers-create.component.html",
  styleUrls: ["./providers-create.component.scss"],
})
export class ProvidersCreateComponent implements OnInit {
  public contentHeader: IContentHeader = null;
  public masterDataForm: FormGroup;
  public siteForm: FormGroup;
  public showErrors: boolean = false;
  public banksList: IBank[] = [];
  public invoiceTypeList: IInvoiceType[] = [];
  public nationsWithCodes: { name: string; code: string }[] = nationsWithCodes;
  public fileName: string = null;
  public logoBase64: string = "";
  public referentForm: FormGroup;

  constructor(
    public _formBuilder: FormBuilder,
    public _citiesService: CitiesService,
    private _listService: ListService,
    private router: Router,
    private _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _providerService: ProvidersService,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CREATE_PROVIDER",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.EXTERNAL_USERS_LIST",
            isLink: true,
            link: "/dashboard/providers/list",
          },
          {
            name: "MENU.CREATE_PROVIDER",
            isLink: false,
          },
        ],
      },
    };
    this.masterDataForm = this._formBuilder.group({
      name: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
      business_name: [null, [Validators.required, Validators.minLength(2), Validators.maxLength(255)]],
      vat_number: [null, [Validators.minLength(9), Validators.maxLength(12)]],
      pec: [null, [Validators.maxLength(255), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      recipient_pec: [null, [Validators.maxLength(255), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      email: [null, [Validators.maxLength(255), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
      fiscalcode: [null, [Validators.maxLength(255)]],
      invoice_type: [null, [Validators.required]],
      bank: [null, [Validators.required]],
      unique_code: [null],
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("create_provider")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.banksList = await this._listService.getList("bank");
    this.invoiceTypeList = await this._listService.getList("invoice_type");
  }

  masterDataHasError(field_name: string): boolean {
    if (this.showErrors) {
      return this.masterDataForm.controls[field_name].status === "INVALID";
    } else {
      return this.masterDataForm.controls[field_name].status === "INVALID" && this.masterDataForm.controls[field_name].touched;
    }
  }

  setAutoProvince() {
    const cityValue: number = this.siteForm.get("city_id").value;
    if (cityValue > 0) {
      const cityObj: ICity = this._citiesService.list.find((city: ICity) => city.id === cityValue);
      const province: ICity = this._citiesService.list.find((city: ICity) => city.initials === cityObj.initials && city.is_main === 1);
      this.siteForm.patchValue({ province_id: province.id });
    }
  }

  async handlerChangeFileInput(event) {
    if (!!event.target.value) {
      this.fileName = event.target.files[0].name;
      this._utilService.convertFileToBase64(event, (e) => {
        this.logoBase64 = e.target.result;
      });
    } else {
      this.logoBase64 = "";
      this.fileName = null;
    }
  }

  async save() {
    if (!this._authenticationService.hasCapability("create_provider")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    if (this.masterDataForm.invalid) {
      this.showErrors = true;
      return false;
    }
    if (!this.masterDataForm.value.fiscalcode && !this.masterDataForm.value.vat_number) {
      await this._utilService.showSWALError({ text: "INSERT_FISCALCODE_OR_VAT_NUMBER" });
      return false;
    }

    const data: IProvider = this.masterDataForm.value;
    this._utilService.showLoading();
    await this._providerService
      .create(data)
      .then(async (response: { id: number }) => {
        this._utilService.hideLoading();
        if (this.logoBase64 && this.logoBase64.length > 0) {
          const fileExtension: string = this.logoBase64.substring("data:image/".length, this.logoBase64.indexOf(";base64"));
          const fileName: string = `logo-${this._utilService.slugify_me(data.name)}.${fileExtension}`;
          const uploadFile = await this._utilService.upload_media("public", fileName, this.logoBase64);
          if (uploadFile) {
            await this._providerService.edit(response.id, { logo: "public/" + fileName }).catch(async () => this._utilService.showSWALError({ text: "ERROR_CREATE_PROVIDER" }));
          }
        }
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_PROVIDER" });
        await this.router.navigateByUrl("/dashboard/providers/edit/" + response.id);
      })
      .catch((err) => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_CREATE_PROVIDER" });
        console.error(err);
      });
  }
}
